import { render, staticRenderFns } from "./ReassignSubmissionModal.vue?vue&type=template&id=173bbccd&scoped=true&"
import script from "./ReassignSubmissionModal.vue?vue&type=script&lang=js&"
export * from "./ReassignSubmissionModal.vue?vue&type=script&lang=js&"
import style0 from "./ReassignSubmissionModal.vue?vue&type=style&index=0&id=173bbccd&scoped=true&lang=scss&"
import style1 from "./ReassignSubmissionModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173bbccd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('173bbccd')) {
      api.createRecord('173bbccd', component.options)
    } else {
      api.reload('173bbccd', component.options)
    }
    module.hot.accept("./ReassignSubmissionModal.vue?vue&type=template&id=173bbccd&scoped=true&", function () {
      api.rerender('173bbccd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/submissions/ReassignSubmissionModal.vue"
export default component.exports